import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx, _cache) {
  const _component_svgs = _resolveComponent("svgs")

  return (_openBlock(), _createBlock(_component_svgs, {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 90 117"
  }, {
    default: _withCtx(() => _cache[0] || (_cache[0] = [
      _createElementVNode("path", {
        fill: "currentColor",
        "fill-rule": "evenodd",
        d: "M45 71.089c19.24 0 34.839-15.914 34.839-35.545C79.839 15.914 64.24 0 45 0 25.76 0 10.161 15.914 10.161 35.544S25.76 71.09 45 71.09",
        "clip-rule": "evenodd"
      }, null, -1),
      _createElementVNode("path", {
        fill: "currentColor",
        d: "M24.677 78.494c-6.478 0-12.73 2.498-17.373 7.01C2.654 90.02 0 96.195 0 102.683v9.873C0 115.011 1.95 117 4.355 117H13.5c-4.5 0 9 0 0 0h45c-4.5 0 4.302 0 0 0h27.145c2.405 0 4.355-1.989 4.355-4.443v-9.873c0-6.488-2.654-12.663-7.304-17.18-4.642-4.512-10.895-7.01-17.373-7.01z"
      }, null, -1)
    ])),
    _: 1
  }))
}
export default { render: render }